// extracted by mini-css-extract-plugin
module.exports = {"container":"countrydetail_container__2KyBM","button":"countrydetail_button__1d_-t","actDetail":"countrydetail_actDetail__3PN9a"};